import { Constants } from '@pwc/pwc-deals-web-common';
import { useEffect, useState } from 'react';
import userTokenService from '../services/security/userTokenService';

type triState = boolean | null;

const useUserReadabilityIfReady = (projectId: number): triState => {
  const [isReadOnlyUser, setIsReadOnlyUser] = useState<triState>(null);

  useEffect(() => {
    // eslint-disable-next-line
    (async () => {
      if (projectId) {
        setIsReadOnlyUser(
          await userTokenService.hasProjectRoles(projectId, [
            Constants.USER_ROLES.PWC_READONLY_DISPLAY,
            Constants.USER_ROLES.PWC_READONLY,
          ])
        );
      }
    })();
  }, [projectId]);

  return isReadOnlyUser;
};

export { useUserReadabilityIfReady };

const useUserReadability = (projectId: number): boolean => {
  const tri = useUserReadabilityIfReady(projectId);
  return tri !== false;
};

export default useUserReadability;
